import { render, staticRenderFns } from "./AnnouncementPage.vue?vue&type=template&id=7d87da9b&scoped=true&"
import script from "./AnnouncementPage.vue?vue&type=script&lang=js&"
export * from "./AnnouncementPage.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementPage.vue?vue&type=style&index=0&id=7d87da9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d87da9b",
  null
  
)

export default component.exports